import React from 'react';

const TipsPage: React.FC = () => {
  return (
    <div className="section">
      <div className="container">
        <h1 className="section-title">نصائح تربوية لأولياء الأمور</h1>
        
        <div className="tip-card">
          <h3>كيف تدعم تعلم طفلك للغة الإنجليزية في المنزل</h3>
          <p>
            يمكن للأهل لعب دور مهم في دعم رحلة أطفالهم في تعلم اللغة الإنجليزية، حتى لو لم تكن اللغة الإنجليزية هي لغتهم الأم.
            إليكم بعض النصائح البسيطة والفعالة:
          </p>
          <ul>
            <li>خصصوا وقتاً يومياً قصيراً (10-15 دقيقة) لممارسة اللغة الإنجليزية من خلال أنشطة ممتعة</li>
            <li>استخدموا تطبيقات وألعاب تعليمية مناسبة لعمر الطفل</li>
            <li>شاهدوا معاً رسوم متحركة أو برامج أطفال باللغة الإنجليزية</li>
            <li>علقوا بطاقات بأسماء الأشياء باللغة الإنجليزية في أنحاء المنزل</li>
          </ul>
        </div>
        
        <div className="tip-card">
          <h3>أهمية الثناء والتشجيع المستمر</h3>
          <p>
            الثقة بالنفس هي مفتاح النجاح في تعلم اللغات. شجعوا أطفالكم على المحاولة والتحدث باللغة الإنجليزية
            دون خوف من الخطأ. احتفلوا بكل تقدم مهما كان صغيراً، واجعلوا التعلم تجربة إيجابية وممتعة.
          </p>
        </div>
        
        <div className="tip-card">
          <h3>دمج اللغة الإنجليزية في الروتين اليومي</h3>
          <p>
            يمكن دمج تعلم اللغة الإنجليزية في الأنشطة اليومية بطرق بسيطة:
          </p>
          <ul>
            <li>تسمية الأطعمة باللغة الإنجليزية أثناء تناول الوجبات</li>
            <li>عد الأشياء باللغة الإنجليزية أثناء التسوق</li>
            <li>غناء أغاني بسيطة باللغة الإنجليزية أثناء الاستحمام أو قبل النوم</li>
            <li>قراءة قصص مصورة باللغة الإنجليزية قبل النوم</li>
          </ul>
        </div>
        
        <div className="tip-card">
          <h3>التعلم من خلال اللعب</h3>
          <p>
            الأطفال يتعلمون بشكل أفضل عندما يستمتعون بما يفعلونه. استخدموا الألعاب والأنشطة التفاعلية لتعزيز تعلم اللغة:
          </p>
          <ul>
            <li>لعبة البحث عن الكنز باستخدام كلمات إنجليزية</li>
            <li>ألعاب الذاكرة باستخدام بطاقات الكلمات والصور</li>
            <li>تمثيل المواقف اليومية باللغة الإنجليزية (مثل التسوق أو زيارة الطبيب)</li>
            <li>ألعاب الحركة مع تعليمات بسيطة باللغة الإنجليزية</li>
          </ul>
        </div>
        
        <div className="tip-card">
          <h3>كيفية التعامل مع التحديات</h3>
          <p>
            قد يواجه بعض الأطفال صعوبات في تعلم اللغة الإنجليزية. إليكم بعض النصائح للتعامل مع هذه التحديات:
          </p>
          <ul>
            <li>تجنبوا المقارنة مع الأطفال الآخرين، فكل طفل يتعلم بوتيرته الخاصة</li>
            <li>قسموا المهام التعليمية إلى خطوات صغيرة يسهل إنجازها</li>
            <li>ركزوا على اهتمامات الطفل واستخدموها كمدخل للتعلم</li>
            <li>تواصلوا مع المعلمة بانتظام لمتابعة تقدم الطفل ومعرفة نقاط القوة والضعف</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TipsPage;
